import getCollection from '../../utils/db/getCollection'
import getDoc from '../../utils/db/getDoc'
import promiseAllValues from '../../utils/promiseAllValues'
import buildRelatedProductSearchIndex from './buildRelatedProductSearchIndex'
import { OUTLET_SHOP_ID } from './outlet/outletCategoryConstants'
import { PREMIUM_ONLINE_SHOP_ID } from './gifts/giftFundCatalogPool'

export const loadRelatedProductCatalog = () =>
  promiseAllValues({
    products: getCollection({ path: 'products', docIdName: 'id' }),
    outletProducts: getCollection({ path: 'outletProducts', docIdName: 'id' }),
    categories: getCollection({ path: 'categories', docIdName: 'id' }),
    brands: getCollection({ path: 'brands', docIdName: 'id' }),
    outletShop: getDoc({ path: 'shops', docId: OUTLET_SHOP_ID, docIdName: 'id' }),
    premiumOnlineShop: getDoc({ path: 'shops', docId: PREMIUM_ONLINE_SHOP_ID, docIdName: 'id' }),
  }).then((data) => buildRelatedProductSearchIndex(data))

export default loadRelatedProductCatalog
